var Reflux = require("reflux");
var agendorAPI = require("app/util/api/agendor-api");
var activitiesAPI = require("app/util/api/activity");
var SignalActions = require("app/shared/actions/signal-actions");
var i18n = require("app/util/i18n/i18n");
var _ = require("underscore");
var moment = require("moment");
var textFormatter = require("app/util/formatter/text");
var fetchActivitiesRequest = null;

var ActivitiesListingActions = Reflux.createActions({
  "getActivities": {children: ["loading", "completed","failed", "filtersChanged"]},
  "getMoreActivities": {children: ["loadingMore", "completed","failed"]},
  "retryGetActivities": {children: ["loading", "completed", "failed"]},
  "finishActivity": {children: ["completed","failed"]},
  "removeActivity": {children: ["completed","failed"]},
  "rescheduleActivity": {children: ["completed","failed"]},
  "hideActivity": {},
  "editActivity": {},
  "cancelEdition": {},
  "push": {},
  "update": {}
});

// TODO remove this method and do this action in ActivityButtonEdit.onClick
ActivitiesListingActions.editActivity.listen(function(activity, instanceKey){
  // TODO check if moving this to ActivityInputActions.setupEdit.preEmit
  // the store will still liten to the action
  var activityInputActions = ActivityInputActions(instanceKey);
  var activityInputStore = ActivityInputStore(instanceKey);

  activityInputActions.setupEdit(activity);
});

function getParams(filters) {
  var params = {};
  if (filters.pending === true) {
    params.pending = true;
    params.assigned_to_user_id = filters.userId;
    if (filters.dtInicial) {
      var initial_due_date = filters.dtInicial + " 00:00:00";

      params.initial_due_date = moment(textFormatter.dateToTimezone(
        initial_due_date,
        window.loggedUserTzId,
        "UTC"
      )).format("YYYY-MM-DD HH:mm:ss");
    }
    if (filters.dtFinal) {
      var final_due_date = filters.dtFinal+" 23:59:59";

      params.final_due_date = moment(textFormatter.dateToTimezone(
        final_due_date,
        window.loggedUserTzId,
        "UTC"
      )).format("YYYY-MM-DD HH:mm:ss");
    }
  } else if (filters.pending === false) {
    params.finished = true;
    params.finished_by_user_id = filters.userId;
    if (filters.dtInicial) {
      var initial_finished_date = filters.dtInicial + " 00:00:00";

      params.initial_finished_date = moment(textFormatter.dateToTimezone(
        initial_finished_date,
        window.loggedUserTzId,
        "UTC"
      )).format("YYYY-MM-DD HH:mm:ss");
    }
    if (filters.dtFinal) {
      var final_finished_date = filters.dtFinal+" 23:59:59";

      params.final_finished_date = moment(textFormatter.dateToTimezone(
        final_finished_date,
        window.loggedUserTzId,
        "UTC"
      )).format("YYYY-MM-DD HH:mm:ss");
    }
  }
  if (filters.initial_creation_date) {
     params.initial_creation_date = moment(textFormatter.dateToTimezone(
       filters.initial_creation_date,
       window.loggedUserTzId,
       "UTC"
     )).format("YYYY-MM-DD HH:mm:ss");
  }
  if (filters.final_creation_date) {
    params.final_creation_date = moment(textFormatter.dateToTimezone(
      filters.final_creation_date,
      window.loggedUserTzId,
      "UTC"
    )).format("YYYY-MM-DD HH:mm:ss");
  }
  if (filters.created_by_user_id) {
    params.created_by_user_id = filters.created_by_user_id;
  }
  if (filters.email) {
    params.email = filters.email;
  }
  if (filters.metric_ids) {
    params.metric_ids = filters.metric_ids;
  }
  if (filters.organization_id) {
    params.organization_id = filters.organization_id;
  }
  if (filters.person_id) {
    params.person_id = filters.person_id;
  }
  if (filters.deal_id) {
    params.deal_id = filters.deal_id;
  }
  if (filters.append_related_people) {
    params.append_related_people = filters.append_related_people;
  }
  if (filters.append_related_deals) {
    params.append_related_deals = filters.append_related_deals;
  }
  params.offset = filters.offset || 0;
  params.page = filters.page || 1;
  params.per_page = filters.per_page || 10;

  return params;
}

function fetchActivities(filters, append) {
  var params = getParams(filters);

  var error = function(err, response) {
    if (err.requestAborted) {
      return false;
    }

    SignalActions.show({
      message: getErrorMessage(err),
      type: "warning",
      hideTimeout: 5000
    });

    this.failed(err);
  }.bind(this);

  var success = function(response) {
    if (!response.error) {
      this.completed(response.body.data, filters, response.body.meta.total, append);
    } else {
      error({customError: true}, response);
    }
  }.bind(this);

  if (fetchActivitiesRequest && fetchActivitiesRequest.abort) {
    // abort old request if there is one
    fetchActivitiesRequest.abort();
  }

  fetchActivitiesRequest = activitiesAPI.list(params, success, error);
}

function getErrorMessage(error) {
  if (error.customError) {
    if (error.clientSideError) {
      return i18n.messages.activities.request_error_message.client_side;
    } else {
      return i18n.messages.activities.request_error_message.server_side.short;
    }
  } else {
    return i18n.messages.activities.request_error_message.generic;
  }
}

ActivitiesListingActions.getActivities.listen(function(filters, append){
  this.loading();
  this.filtersChanged(filters);

  var boundFetchActivities = fetchActivities.bind(this);
  boundFetchActivities(filters, append);
});

ActivitiesListingActions.getMoreActivities.listen(function(filters, append){
  this.loadingMore();

  var newFilters = _.clone(filters);
  newFilters.page++;
  var boundFetchActivities = fetchActivities.bind(this);
  boundFetchActivities(newFilters, append);
});

ActivitiesListingActions.retryGetActivities.listen(function(filters) {
  this.loading();

  var boundFetchActivities = fetchActivities.bind(this);
  boundFetchActivities(filters, false);
});

ActivitiesListingActions.rescheduleActivity.listen(function(activityId, newDueDate, oldDueDate, newTimezone, oldTimezone){
  this.completed(activityId, newDueDate, newTimezone);

  var url = "/activities/"+activityId;
  var params = {
    due_date: newDueDate
  };

  agendorAPI.put(url, params, function(activities, response) {
    if(response.status==204||response.status==200){
      this.completed(activityId, newDueDate, newTimezone);
    } else {
      var errorMsg = null;
      if(response.status==403) {
        errorMsg = "Você não possui permissão para reagendar esta tarefa.";
      } else {
        errorMsg = "Não foi possível reagendar esta tarefa.";
      }

      SignalActions.show({ message: errorMsg, type: "warning" });
      this.completed(activityId, oldDueDate, oldTimezone);
    }
  }.bind(this));
});

ActivitiesListingActions.finishActivity.listen(function(activityId, finished){
  var finishedDate = ((finished)?new Date():null);
  this.completed(activityId, finishedDate, finished);

  var url = "/activities/"+activityId;
  var params = {
    finished: finished
  };

  agendorAPI.put(url, params, function(activities, response) {
    if(response.status==204||response.status==200){
      this.completed(activityId, finishedDate, finished, response.body);
      mixpanelIncrementSuperProperty("Tarefas finalizadas", 1);
      mixpanel.people.increment("Tarefas finalizadas", 1);
      mixpanel.track("Tarefa finalizada", {
        "ID do cliente": window.loggedUserAccountId
      });
    } else {
      var errorMsg = null;
      if(response.status==403) {
        errorMsg = "Você não possui permissão para finalizar esta tarefa.";
      } else {
        errorMsg = "Não foi possível finalizar esta tarefa.";
      }

      SignalActions.show({ message: errorMsg, type: "warning" });
      this.completed(activityId, null, !finished);
    }
  }.bind(this));

});

ActivitiesListingActions.removeActivity.listen(function(activityId){
  var url = "/activities/"+activityId;

  agendorAPI.del(url, {}, function(body, response) {
    if(response.status==204||response.status==200){
      this.completed(activityId);
    } else {
      var errorMsg = null;
      if(response.status==403) {
        errorMsg = "Você não possui permissão para excluir esta tarefa.";
      } else {
        errorMsg = "Não foi possível excluir esta tarefa.";
      }

      SignalActions.show({ message: errorMsg, type: "warning" });
    }
  }.bind(this));

});

module.exports = ActivitiesListingActions;

var SignalActions = require("app/shared/actions/signal-actions");
var ActivityInputActions = require("app/screens/Activity/actions/activity-input-actions");
var ActivityInputStore = require("app/screens/Activity/stores/activity-input-store");



// WEBPACK FOOTER //
// ./app/screens/Activity/actions/activities-listing-actions.js